import { useState } from 'react';
import { RangeClient, RangeDTO, UpdateRangeStatusDTO, ApiResponse_string } from '../services/apiClient';
import { API_BASE_URL } from '../config/config';
import axiosInstance from '../services/axiosInstance';
import { handleHookError } from '../utils/hookUtils/handleHookError';

export const useRangeApi = () => {
    const apiClient = new RangeClient(API_BASE_URL, axiosInstance);

    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const create = async (data: RangeDTO) => {
        setIsLoading(true);
        try {
            await apiClient.createRange(data);
        } catch (err: any) {
            setError(err.message || 'Error creating Range');
        } finally {
            setIsLoading(false);
        }
    };

    const edit = async (id: string, data: RangeDTO) => {
        setIsLoading(true);
        try {
            await apiClient.updateRange(id, data);
        } catch (err: any) {
            setError(err.message || 'Error updating Range');
        } finally {
            setIsLoading(false);
        }
    };

    const getById = async (id: string) => {
        setIsLoading(true);
        try {
            return await apiClient.getRangeById(id);
        } catch (err: any) {
            setError(err.message || 'Error fetching Range');
        } finally {
            setIsLoading(false);
        }
    };

    const search = async (filters: any) => {
        setIsLoading(true);
        try {
            return await apiClient.searchRanges(filters);
        } catch (err: any) {
            setError(err.message || 'Error searching Ranges');
        } finally {
            setIsLoading(false);
        }
    };

    const remove = async (id: string) => {
        setIsLoading(true);
        try {
            await apiClient.deleteRange(id);
        } catch (err: any) {
            setError(err.message || 'Error deleting Range');
        } finally {
            setIsLoading(false);
        }
    };

    const updateStatus = async (data: UpdateRangeStatusDTO) => {
        setIsLoading(true);
        try {
            return await apiClient.updateRangeQuickStatus(data);
        } catch (err: any) {
            setError(err.message || 'Error updating range status');
            throw err;
        } finally {
            setIsLoading(false);
        }
    };

    return { create, edit, getById, search, remove, updateStatus, isLoading, error };
};